module.exports = __webpack_public_path__ + "static/media/plus-add.2309dac5.svg";